<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}" class="dimmed_black" style="top:0;display:block;"></div>
    <div
      :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big"
      id="pop_changeDate"
      style="display: block">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">NTC 정기기부 상품 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel">
            <span>닫기</span>
          </button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
            <span class="rew19_table_tit" v-if="viewData.pd_list && viewData.pd_list.length > 0">총 {{viewData.pd_list.length}}개 상품</span>
            <span class="rew19_table_tit" v-else>총 {{viewData.product1Quantity + viewData.product5Quantity}}개 상품</span>
          </dt>

          <div v-for="(pd, idx) in viewData.pd_list" v-bind:key="idx" class="rew19_payment_content" v-show="viewData.pd_list && viewData.pd_list.length > 0">
            <dd class="rew19_dividing_line">
              <div class="rew19_product_tit">{{pd.pd_name_kr}}</div>
              <div class="rew19_product_cont">
                <div class="rew19_relative rew19_relative_add rew19_change_position">
                  <div class="rew19_goodsWrap">
                    <div class="rew19_goodsImg dev-productDetail" v-bind:data-prodid="pd.pd_id">
                      <i class="rew19_goodsFlag"></i>
                      <span class="rew19_rateImg">
                        <img
                          v-bind:src="pd.pd_img_url1"
                          onError="imageError(this)" data-error-cnt="0"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="rew19_product_select">
                    <ul class="rew19_product_items">
                      <li>
                        <em class="rew19_gTit">정기구매가</em>
                        <span class="rew19_gDetail">
                          <strong v-bind:id="pd.pd_id+'_check_prod_price'" v-bind:data-price="pd.pd_amt">{{$fmt.WON(pd.pd_amt)}}</strong>원
                        </span>
                      </li>

                      <li v-if="getMemberType() == 'DIST'">
                        <em class="rew19_gTit">NTC SV</em>
                        <span class="rew19_gDetail" v-bind:id="pd.pd_id+'_check_prod_pv'">{{$fmt.PV(pd.pv)}}</span>
                      </li>
                    </ul>
                    <div class="rew19_numbering_wrap">
                      <em class="rew19_gTit">수량</em>
                      <div
                        class="rew19_numbering"
                        v-bind:data-prodid="pd.pd_id"
                        data-groupid="0"
                        data-pdorderunit
                      >
                        <a
                          @click="onClickUpdateProductCount(pd.pd_id, -1, null)"
                          class="rew19_numbering_down dev-prod-qty-down"
                          title="감소"
                        ></a>
                        <input
                          v-model="pd.pd_count"
                          @keypress="numberKeyPress($event)"
                          @keyup="onClickUpdateProductCount(pd.pd_id)"
                          :readonly="pd.pd_count"
                          type="tel"
                          class="onlynum dev-prod-qty"
                          title="수량"
                        />
                        <a @click="onClickUpdateProductCount(pd.pd_id, +1, null)" class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                      </div>

                      <div class="rew19_summary_wrap">
                        <em class="rew19_gTit">합계</em>
                        <span class="rew19_gDetail">
                          <strong>{{$fmt.WON(pd.pd_total_amt)}}</strong>원
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--//rew19_product_select-->
                </div>
                <!--//rew19_relative-->
              </div>
            </dd>
          </div>

          <div v-show="viewData.pd_list && viewData.pd_list.length <= 0">
            <dd class="rew19_dividing_line">
              <div class="rew19_product_tit">바이타밀 1포</div>
              <!--//rew19_product_tit-->
              <div class="rew19_product_cont">
                <div class="rew19_relative rew19_relative_add rew19_change_position">
                  <div class="rew19_goodsWrap">
                    <div class="rew19_goodsImg dev-productDetail" data-prodid="18111721">
                      <i class="rew19_goodsFlag"></i>
                      <span class="rew19_rateImg">
                        <img
                          :src="viewData.p1_pd_img_url1"
                          onError="imageError(this)" data-error-cnt="0"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="rew19_product_select">
                    <ul class="rew19_product_items">
                      <li>
                        <em class="rew19_gTit">정기구매가</em>
                        <span class="rew19_gDetail">
                          <strong id="18125002_check_prod_price" data-price="4200.0">{{$fmt.WON(viewData.product1Price)}}</strong>원
                        </span>
                      </li>

                      <li v-if="getMemberType() == 'DIST'">
                        <em class="rew19_gTit">NTC SV</em>
                        <span class="rew19_gDetail" id="18125002_check_prod_pv">{{$fmt.PV(viewData.product1Pv)}}</span>
                      </li>
                    </ul>
                    <div class="rew19_numbering_wrap">
                      <em class="rew19_gTit">수량</em>
                      <div
                        class="rew19_numbering"
                        data-prodid="18125002"
                        data-groupid="0"
                        data-pdorderunit
                      >
                        <a
                          @click="onClickUpdateProductCount(null, -1, 1)"
                          class="rew19_numbering_down dev-prod-qty-down"
                          title="감소"
                        ></a>
                        <input
                          v-model="viewData.product1Quantity"
                          @keypress="numberKeyPress($event)"
                          @keyup="onClickUpdateProductCount(null, null, 1)"
                          :readonly="viewData.product1Quantity"
                          type="tel"
                          class="onlynum dev-prod-qty"
                          title="수량"
                        />
                        <a @click="onClickUpdateProductCount(null, +1, 1)" class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                      </div>

                      <div class="rew19_summary_wrap">
                        <em class="rew19_gTit">합계</em>
                        <span class="rew19_gDetail">
                          <strong>{{$fmt.WON(viewData.totalProduct1Price)}}</strong>원
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--//rew19_product_select-->
                </div>
                <!--//rew19_relative-->
              </div>
            </dd>
            <dd class="rew19_dividing_line">
              <div class="rew19_product_tit">바이타밀 5포</div>
              <!--//rew19_product_tit-->
              <div class="rew19_product_cont">
                <div class="rew19_relative rew19_relative_add rew19_change_position">
                  <div class="rew19_goodsWrap">
                    <div class="rew19_goodsImg dev-productDetail" data-prodid="18111721">
                      <i class="rew19_goodsFlag"></i>
                      <span class="rew19_rateImg">
                        <img :src="viewData.p5_pd_img_url1" onError="imageError(this)" data-error-cnt="0" />
                      </span>
                    </div>
                  </div>
                  <div class="rew19_product_select">
                    <ul class="rew19_product_items">
                      <li>
                        <em class="rew19_gTit">정기구매가</em>
                        <span class="rew19_gDetail">
                          <strong id="18125002_check_prod_price" data-price="4200.0">{{$fmt.WON(viewData.product5Price)}}</strong>원
                        </span>
                      </li>

                      <li v-if="getMemberType() == 'DIST'">
                        <em class="rew19_gTit">NTC SV</em>
                        <span class="rew19_gDetail" id="18125002_check_prod_pv">{{$fmt.PV(viewData.product5Pv)}}</span>
                      </li>
                    </ul>
                    <div class="rew19_numbering_wrap">
                      <em class="rew19_gTit">수량</em>
                      <div
                        class="rew19_numbering"
                        data-prodid="18125002"
                        data-groupid="0"
                        data-pdorderunit
                      >
                        <a
                          @click="onClickUpdateProductCount(null, -1, 5)"
                          class="rew19_numbering_down dev-prod-qty-down"
                          title="감소"
                        ></a>
                        <input
                          v-model="viewData.product5Quantity"
                          @keypress="numberKeyPress($event)"
                          @keyup="onClickUpdateProductCount(null, null, 5)"
                          :readonly="viewData.product5Quantity"
                          type="tel"
                          class="onlynum dev-prod-qty"
                          title="수량"
                        />
                        <a @click="onClickUpdateProductCount(null, +1, 5)" class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                      </div>

                      <div class="rew19_summary_wrap">
                        <em class="rew19_gTit">합계</em>
                        <span class="rew19_gDetail">
                          <strong>{{$fmt.WON(viewData.totalProduct5Price)}}</strong>원
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--//rew19_product_select-->
                </div>
                <!--//rew19_relative-->
              </div>
            </dd>
          </div>
        </dl>

        <div class="rew19_payment_bottom">
          <ul class="rew19_payList">
            <li v-if="getMemberType() == 'DIST'">
              <em class="rew19_payTitle">합계 SV</em>
              <span class="rew19_payDetail">{{$fmt.PV(viewData.totalPv)}}</span>
            </li>
            <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
              <em class="rew19_payTitle">주문금액</em>
              <span class="rew19_payDetail rew19_point">
                <strong>{{$fmt.WON(viewData.totalPrice)}} 원</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">변경완료</button>
      </div>
    </div>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "NtcProductDialog",
  extends: AroBase,
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,
      prod_cd_ntc1 : "18113523",
      prod_cd_ntc5 : "18113527",
      prod_cd_ntc10 : "18001857",

      viewData: {
      },

      ntc_product_1sv : null,
      ntc_product_5sv : null,

    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {

      let _this = this;
      let resData = [];

      var pd_list = _this.viewData.pd_list;

      if(pd_list){
        for(var i=0; i< pd_list.length; i++){
          var tempItem = {};
          tempItem.pd_id = pd_list[i].pd_id;
          tempItem.pd_count = pd_list[i].pd_count;
          resData.push(tempItem);
        }
      }else{
        resData = [{
            product1Quantity : _this.viewData.product1Quantity,
            product5Quantity : _this.viewData.product5Quantity
          }];
      }

      _this.$emit('close', response, response ? resData: null);
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */

    /**
     * Local
     */
    initData: function(data) {
      let _this = this;

      //let newData = data
      let newData = JSON.parse(JSON.stringify(data));

      _this.viewData = {
        ..._this.viewData,
        ...newData
      };

      var pd_list = _this.viewData.pd_list;

      if(pd_list){
        for(var i=0; i< pd_list.length; i++){
          var product = pd_list[i];
          product.pd_total_pv = product.pv * product.pd_count;
        }
      }else{
        _this.ntc_product_1sv = _this.viewData.product1Pv;
        _this.ntc_product_5sv = _this.viewData.product5Pv;

        _this.viewData.product1Pv = _this.viewData.product1Pv * _this.viewData.product1Quantity;
        _this.viewData.product5Pv = _this.viewData.product5Pv * _this.viewData.product5Quantity;
      }
    },

    //상품 수량 변경 (newType에는 상품ID가 oldType에는 NTC상품이 1개짜리인지 5개짜리인지 숫자텍스트가 하드코딩되어 들어 옴)
    onClickUpdateProductCount(newType, add, oldType){
      let _this =  this;
      let oldCnt = 0;
      let newCnt = oldCnt;
      let usingText = undefined === add || null === add;
      let pd_count = 0;

      if(newType && null == oldType){
        var pd_list = _this.viewData.pd_list;
        for(var i=0; i< pd_list.length; i++){
          var product = pd_list[i];
          if(newType === product.pd_id){
            pd_count = product.pd_count;
          }
        }
      }else{
        if("1" == oldType){
          pd_count = _this.viewData.product1Quantity;
        }else if("5" == oldType){
          pd_count = _this.viewData.product5Quantity;
        }
      }


      if(!pd_count || pd_count == NaN){
        oldCnt = newCnt = 0;
      }else{
        oldCnt = (""+pd_count).replace(/[^0-9]/g, "");
        oldCnt = parseInt(""+oldCnt, 10);
      }

      if(usingText){
        newCnt = oldCnt;
      }else{
        newCnt = oldCnt + add;
      }

      if(newCnt < 0){
        newCnt = 0;
      }


      let total_pv = 0;
      let total_price = 0;

      if(newType && null == oldType){

        var pd_list = _this.viewData.pd_list;
        for(var i=0; i< pd_list.length; i++){
          var product = pd_list[i];
          if(newType === product.pd_id){
            product.pd_count = newCnt;
            product.pd_total_amt = product.pd_amt * newCnt;
            product.pd_total_pv = product.pv * newCnt;
          }

          total_price += product.pd_total_amt;
          total_pv += product.pd_total_pv;
        }

      }else{
        if(oldType == '1'){
          _this.viewData.product1Quantity = newCnt;
          _this.viewData.totalProduct1Price = _this.viewData.product1Price * newCnt;
          _this.viewData.product1Pv = _this.ntc_product_1sv * newCnt;
        }else if(oldType == '5'){
          _this.viewData.product5Quantity = newCnt;
          _this.viewData.totalProduct5Price = _this.viewData.product5Price * newCnt;
          _this.viewData.product5Pv = _this.ntc_product_5sv * newCnt;
        }

        total_price = _this.viewData.totalProduct1Price + _this.viewData.totalProduct5Price;
        total_pv = _this.viewData.product1Pv + _this.viewData.product5Pv;
      }

      _this.viewData.totalPrice = total_price;
      _this.viewData.totalPv = total_pv;
    },
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/NtcProductDialog.vue